import { IndexBalanceCheckSearch } from "components/UI/molecules";
import "./index.scss";
import { BalanceCheckList } from "components/UI/organisms";

export const GiftCardBalance = () => {
  return (
    <div className="gift-card-balance-container">
      <h1>View the Balance of Your Gift Card</h1>
      <div className="balance-description-container">
        <p>
          Check your gift card balance on the GCX by selecting a brand name
          below. We provide gift card balance links for thousands of retailers
          and restaurants so you can easily check your gift card balance online.
          Use our gift card balance checker to find out how much value is
          remaining on your card in just a few simple steps. Select the brand
          name of the gift card to verify, and enter the gift card's information
          on the merchant website. You may be asked to submit your gift card
          number and gift card PIN to verify the balance. You can find these
          numbers and/or characters exactly as they appear on the back of the
          gift card. If you are unable to check your card balance online, please
          direct all inquiries to the merchant's phone number provided for gift
          card balance verification.
        </p>
        <p>
          GCX offers a convenient way for you to check your gift card balance
          online or over the phone. Especially when selling these cards on our
          gift card exchange, it is important to verify a gift card's balance to
          ensure an accurate value. We verify all gift cards before listing on
          the marketplace to provide our buyers with the correct gift card
          information. All sellers on GCX are held responsible for the full gift
          card balance at the original time of listing, therefore it's important
          to know the exact gift card balance when listing your item for sale.
        </p>
      </div>
      <IndexBalanceCheckSearch />
      <BalanceCheckList />
    </div>
  );
};
